import { ErrorHandler, Injectable, NgZone, Injector } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';

import { LoggingMessageService } from './services/logging-message.service';
import { ErrorService } from './services/error.service';
import { AuthService } from './services/auth.service';
import { environment } from 'src/environments/environment';


@Injectable()
/**
 * Default error handling including logging and navigation.
 * Use a try/catch block whenever you don't want errors propagating up to here.
 */
export class UIErrorHandler extends ErrorHandler {

    constructor(public zone: NgZone, private injector: Injector,
                private logger: LoggingMessageService,
                private authenticationService: AuthService,
                private errorService: ErrorService) {
        super();
    }

    /** Default logging and navigation */
    handleError(error) {
        super.handleError(error);

        this.handleLogging(error);
        this.handleNavigation(error);
    }

    private handleLogging(error) {
        const selectedSubscriptionID = this.authenticationService.SelectedSubscription;
        const availableSubscriptions = this.authenticationService.AvailableSubscriptionsString ;

        if (!navigator.onLine) {
             this.logger.error('error-handler', 'handleLogging', selectedSubscriptionID, availableSubscriptions, `Offline Error: ${error.message}`, error.stack);
            this.errorService.errorMessage = 'Unavailable - Network Offline';
        } else if (error instanceof HttpErrorResponse) {
            // Logged by Interceptor
            this.errorService.errorMessage = `Service Responded with an error - ${error.statusText}`;
        } else if (error instanceof TypeError) {
             this.logger.error('error-handler', 'handleLogging', selectedSubscriptionID, availableSubscriptions, `Type Error: ${error.message}`, error.stack);
            this.errorService.errorMessage = 'Unavailable - TypeError';
        } else if (error instanceof Error) {
             this.logger.error('error-handler', 'handleLogging', selectedSubscriptionID, availableSubscriptions,  `General Error: ${error.message}`, error.stack);
            this.errorService.errorMessage = 'Unavailable - General Error';
        } else {
             this.logger.error('error-handler', 'handleLogging', selectedSubscriptionID, availableSubscriptions, `Unexpected: ${error.message}`, error.stack);
            this.errorService.errorMessage = 'Unavailable - Unexpected Error';
        }
    }

    private handleNavigation(error) {
        this.zone.run(() => {
            const router = this.injector.get(Router);
            if ((error instanceof HttpErrorResponse) && (error.status === 401)) {
                router.navigate(['/unauthorized']);
            } else {
                router.navigate(['/**/']);
            }
        });
    }
}
